import type { ShaderMaterial } from "three";
import type { AtmosphereUniforms } from "../atmosphere.ts";
import { createSurfaceMaterial, withRole } from "./surface.ts";

/** Contorno de luz dos avatares: o meio-termo da camisa (1) e da pele (0,6) dos bonecos de antes. */
export const AVATAR_RIM = 0.8;

/** Um material por atmosfera (cada partida monta a sua, como no `toonMaterial`) e variantes com energia independente por ator. */
const caches = new WeakMap<AtmosphereUniforms, ShaderMaterial>();

/**
 * Material dos avatares animados (F49): o de superfície (F51) com cor por vértice, normal por face, a
 * máscara do contorno e sem o rim noturno (que é das assombrações). O skinning o three liga sozinho no
 * `SkinnedMesh` (`USE_SKINNING`), sem fonte nova. A base é compartilhada; a variante de cada ator mantém a cor da classe e sua energia independente.
 */
export function avatarMaterial(atmosphere: AtmosphereUniforms, slotHex?: string): ShaderMaterial {
  let material = caches.get(atmosphere);
  if (!material) {
    material = createSurfaceMaterial({ atmosphere, name: "avatar", vertexColors: true, outline: true, rim: AVATAR_RIM, nightRim: false, role: "heroi" });
    caches.set(atmosphere, material);
  }
  if (slotHex === undefined) return material;
  // Cada ator possui seus uniforms de energia; a fonte/defines continuam compartilhando o programa.
  // O consumidor é dono desta variante e a descarta ao remover o ator.
  return withRole(material, "heroi", slotHex);
}
